import { useMutation, MutationHookOptions } from '@apollo/client';
import MUTATION from '../operations/RequestTrendingInfluencersSpreadsheet.graphql';
import { Mutation, MutationrequestTrendingInfluencersSpreadsheetArgs } from '../../__generated__/globalTypes';

export const useRequestTrendingInfluencersSpreadsheetMutation = (
  options?: MutationHookOptions<Mutation, MutationrequestTrendingInfluencersSpreadsheetArgs>
) => {
  const [callRequestTrendingInfluencersSpreadsheet, result] = useMutation<
    Mutation,
    MutationrequestTrendingInfluencersSpreadsheetArgs
  >(MUTATION, options);

  return { callRequestTrendingInfluencersSpreadsheet, ...result };
};

export type RequestTrendingInfluencersSpreadsheetMutationFunction = Mutation['requestTrendingInfluencersSpreadsheet'];
